import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/@babel/runtime/regenerator/index.js";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import React, { useState, useEffect } from "react";
import Head from "next/head";
import { PageLayout } from "../../util/constants";
import { useIsMobile } from "@dp/xcomp";
import i18next from "i18next";
import { ORDER_TYPES } from "@dp/common";
var RestaurantDetails = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.RestaurantDetails;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
function _getSlugs(pathWithQueryParams) {
  var slugs = [];
  var queryParams = "";
  var effectivePath = pathWithQueryParams.replace("/locations", "");
  if (effectivePath.indexOf("?") !== -1) {
    var _effectivePath$split = effectivePath.split("?"),
      _effectivePath$split2 = _slicedToArray(_effectivePath$split, 2),
      _slugs = _effectivePath$split2[0],
      _query = _effectivePath$split2[1];
    slugs = _slugs.split("/");
    queryParams = _query.length && "?".concat(_query);
  } else {
    slugs = effectivePath.split("/");
  }
  return {
    slugs: slugs.filter(function (f) {
      return f.length > 0;
    }),
    queryParams: queryParams
  };
}
var RestaurantDetailsPage = function RestaurantDetailsPage() {
  var _router$query, _store$common, _store$restaurant, _configs$seo, _configs$seo2;
  var store = useStore();
  var router = useRouter();
  var isMobile = useIsMobile();
  var isFromCancelWaitlist = (router === null || router === void 0 || (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.from) === "cancel_waitlist";
  var _useState = useState(""),
    title = _useState[0],
    setTile = _useState[1];
  var _useState2 = useState(""),
    metaDescription = _useState2[0],
    setMetaDescription = _useState2[1];
  var configs = store === null || store === void 0 || (_store$common = store.common) === null || _store$common === void 0 || (_store$common = _store$common.appAttributes) === null || _store$common === void 0 ? void 0 : _store$common.configs;
  var _getSlugs2 = _getSlugs(router.asPath),
    slugs = _getSlugs2.slugs;
  var restNum = slugs.pop();
  var enableLocationDetail = store === null || store === void 0 || (_store$restaurant = store.restaurant) === null || _store$restaurant === void 0 || (_store$restaurant = _store$restaurant.restaurantDetailModel) === null || _store$restaurant === void 0 || (_store$restaurant = _store$restaurant.selectedRestaurantInLocation) === null || _store$restaurant === void 0 || (_store$restaurant = _store$restaurant.features) === null || _store$restaurant === void 0 ? void 0 : _store$restaurant.locationDetailEnabled;

  // @ts-expect-error types
  var ogTitle = configs === null || configs === void 0 || (_configs$seo = configs.seo) === null || _configs$seo === void 0 || (_configs$seo = _configs$seo.restdetails) === null || _configs$seo === void 0 || (_configs$seo = _configs$seo.meta) === null || _configs$seo === void 0 || (_configs$seo = _configs$seo.image) === null || _configs$seo === void 0 ? void 0 : _configs$seo.title;
  // @ts-expect-error types
  var ogImage = configs === null || configs === void 0 || (_configs$seo2 = configs.seo) === null || _configs$seo2 === void 0 || (_configs$seo2 = _configs$seo2.restdetails) === null || _configs$seo2 === void 0 || (_configs$seo2 = _configs$seo2.meta) === null || _configs$seo2 === void 0 || (_configs$seo2 = _configs$seo2.image) === null || _configs$seo2 === void 0 ? void 0 : _configs$seo2.url;
  useEffect(function () {
    var _store$initComponent;
    store === null || store === void 0 || (_store$initComponent = store.initComponent("RestaurantDetails")) === null || _store$initComponent === void 0 || _store$initComponent.then(function () {
      return handleRestaurantDetails();
    }).then(function (restaurantDetail) {
      var _store$user, _restaurantDetail$fea, _store$restaurant2;
      if ((store === null || store === void 0 || (_store$user = store.user) === null || _store$user === void 0 || (_store$user = _store$user.sessionDetails) === null || _store$user === void 0 || (_store$user = _store$user.orderContext) === null || _store$user === void 0 ? void 0 : _store$user.orderTypeValue) !== ORDER_TYPES.ORDER_AHEAD || restaurantDetail !== null && restaurantDetail !== void 0 && (_restaurantDetail$fea = restaurantDetail.features) !== null && _restaurantDetail$fea !== void 0 && _restaurantDetail$fea.orderAheadEnabled) {
        var _store$menuList;
        //making location sticky on every navigation
        store === null || store === void 0 || (_store$menuList = store.menuList) === null || _store$menuList === void 0 || _store$menuList.selectRestaurant(restaurantDetail === null || restaurantDetail === void 0 ? void 0 : restaurantDetail.restaurantNumber);
      }
      if (isFromCancelWaitlist) store === null || store === void 0 || (_store$restaurant2 = store.restaurant) === null || _store$restaurant2 === void 0 || _store$restaurant2.showCancelWaitlistSuccessMessage();
    }).then(function () {
      var _store$joinWaitlist;
      store === null || store === void 0 || (_store$joinWaitlist = store.joinWaitlist) === null || _store$joinWaitlist === void 0 || _store$joinWaitlist.getWaitlist(isFromCancelWaitlist);
    });
  }, []);
  useEffect(function () {
    if (isNaN(Number(restNum))) {
      router.push("/404");
    }
  }, [restNum]);
  useEffect(function () {
    if (enableLocationDetail === false) {
      router.push("/404");
    }
  }, [enableLocationDetail]);
  useEffect(function () {
    var _store$restaurant3;
    store === null || store === void 0 || (_store$restaurant3 = store.restaurant) === null || _store$restaurant3 === void 0 || _store$restaurant3.fetchTargetter(restNum, isMobile);
  }, [isMobile]);
  function handleRestaurantDetails() {
    return _handleRestaurantDetails.apply(this, arguments);
  }
  function _handleRestaurantDetails() {
    _handleRestaurantDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return goToRestaurant(restNum);
          case 2:
            return _context2.abrupt("return", _context2.sent);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _handleRestaurantDetails.apply(this, arguments);
  }
  var goToRestaurant = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_restNum) {
      var _store$user2, _store$restaurant4, _store$restaurant5;
      var currentLocation, currentRestaurantPage, _store$platformUtil;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            currentLocation = store === null || store === void 0 || (_store$user2 = store.user) === null || _store$user2 === void 0 ? void 0 : _store$user2.currentUserLocation;
            _context.next = 3;
            return store === null || store === void 0 || (_store$restaurant4 = store.restaurant) === null || _store$restaurant4 === void 0 ? void 0 : _store$restaurant4.fetchLocationRestaurant(currentLocation, _restNum);
          case 3:
            currentRestaurantPage = _context.sent;
            if (store !== null && store !== void 0 && (_store$restaurant5 = store.restaurant) !== null && _store$restaurant5 !== void 0 && (_store$restaurant5 = _store$restaurant5.restaurantDetailModel) !== null && _store$restaurant5 !== void 0 && _store$restaurant5.isPermanentlyClosed) {
              store === null || store === void 0 || (_store$platformUtil = store.platformUtil) === null || _store$platformUtil === void 0 || _store$platformUtil.redirectToURL("/locations/location-search?closed=true");
            }
            if (currentRestaurantPage) {
              setTile("".concat(currentRestaurantPage === null || currentRestaurantPage === void 0 ? void 0 : currentRestaurantPage.restaurantName, " ").concat(i18next.t("title.restdetails.pagetitle", {
                defaultValue: ""
              })));
              setMetaDescription(currentRestaurantPage === null || currentRestaurantPage === void 0 ? void 0 : currentRestaurantPage.metaDescription);
            }
            return _context.abrupt("return", currentRestaurantPage);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function goToRestaurant(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var getRobotsContent = function getRobotsContent() {
    var _contents$filter;
    for (var _len = arguments.length, contents = new Array(_len), _key = 0; _key < _len; _key++) {
      contents[_key] = arguments[_key];
    }
    return contents === null || contents === void 0 || (_contents$filter = contents.filter(function (content) {
      return content;
    })) === null || _contents$filter === void 0 ? void 0 : _contents$filter.join(",");
  };
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, title), __jsx("meta", {
    name: "description",
    content: metaDescription
  }), (configs === null || configs === void 0 ? void 0 : configs.isNoIndexEnabled) === "true" && __jsx("meta", {
    name: "robots",
    content: configs === null || configs === void 0 ? void 0 : configs.robotNoIndexContent
  }), __jsx("meta", {
    name: "robots",
    content: getRobotsContent(configs === null || configs === void 0 ? void 0 : configs.robotContent1, configs === null || configs === void 0 ? void 0 : configs.robotContent2)
  }), (configs === null || configs === void 0 ? void 0 : configs.googleVerificationContent) && __jsx("meta", {
    name: configs === null || configs === void 0 ? void 0 : configs.googleVerificationContentName,
    content: configs === null || configs === void 0 ? void 0 : configs.googleVerificationContent
  }), (configs === null || configs === void 0 ? void 0 : configs.youtubeVerificationContent) && __jsx("meta", {
    name: configs === null || configs === void 0 ? void 0 : configs.youtubeVerificationContentName,
    content: configs === null || configs === void 0 ? void 0 : configs.youtubeVerificationContent
  }), ogTitle && __jsx("meta", {
    property: "og:title",
    content: ogTitle
  }), ogImage && __jsx("meta", {
    property: "og:image",
    content: ogImage
  })), __jsx(RestaurantDetails, null));
};
RestaurantDetailsPage.layout = PageLayout.NB_LAYOUT;
export default observer(RestaurantDetailsPage);